import { InjectableClass } from '@fino/lib-injection';

export class PdfViewerController extends InjectableClass {
  constructor(controllerService, $sce, $http, $timeout, $element) {
    'ngInject';
    super({ controllerService, $sce, $http, $timeout });

    $element.addClass('pdf-viewer');
  }

  $onInit() {
    this.pdfLoading = true;
  }

  $onChanges(changes) {
    if (changes.url || (changes.overlay && !changes.overlay.currentValue)) {
      this.setPdfUrl();
    }
  }

  setPdfUrl() {
    const { $sce, $http, url } = this;
    if (!url) {
      return;
    }

    if (this.redirect) {
      // Get direct URL for displaying file in browser if redirect request
      $http.get(url, { params: { type: 'redirect' } })
        .then(response => {
          const { location } = response.data;
          this.pdfUrl = $sce.trustAsResourceUrl(location);
        });
    } else {
      // Set given pdf as trusted resource
      this.pdfUrl = $sce.trustAsResourceUrl(url);
    }
  }

  onload() {
    this.$timeout(() => this.pdfLoading = false);
  }
}
